import { h } from 'preact';
import * as BaseComp from 'components/bolt/toutVertical/toutVertical.js';
import Store from 'store/store';
import { getDynamicData } from 'utils/bolt/dynamicData';
// import s from 'components/bolt/toutVertical/toutVertical.sss';

export default class ToutVertical extends BaseComp.default {
	async componentDidMount(...args) {
		super.componentDidMount?.(...args);
		if (this.props.id === 'promoBanners') {
			const dynamicData = await getDynamicData('landing');
			if (!dynamicData?.promo) {
				return;
			}
			this.toutStacks = [
				{
					touts: [
						{
							title: dynamicData.promo.title,
							description: dynamicData.promo.description,
							button: dynamicData.promo.button,
							path: dynamicData.promo.link,
							src: dynamicData.promo.img,
							alt: dynamicData.promo.alt,
						}
					]
				}
			];
		}
	}

	triggerButtonClick(data) {
		Store.emit('CUSTOM_EVENT', {
			category: Store.get().activePage.replace('Scroll', ''),
			action: 'promo-banner-button-click',
			label: data.button
		});

		super.triggerButtonClick(data);
	}
}
